import { type MediaKind } from '../entity/api/media';
import {
  type CreateMediaRes,
  type DeleteMediaRes,
  type GetByRefDocRes,
  type ListRes,
  createMediaReqSchema,
} from '../entity/api/routes/media';
import { apiRequest, setURL } from './request';

export type CreateMediaWithFileParams = {
  file: File;
  refDocId: string;
  organizationId: string;
  kind: MediaKind;
};

export async function createMediaWithFile(params: CreateMediaWithFileParams) {
  const { file, refDocId, organizationId, kind } = params;

  // Validate the body params
  createMediaReqSchema.shape.body.parse({
    refDocId,
    organizationId,
    kind,
  });

  const formData = new FormData();
  formData.append('refDocId', refDocId);
  formData.append('organizationId', organizationId);
  formData.append('kind', kind);
  formData.append('file', file);

  const url = setURL('/media', null);
  const res = await apiRequest<CreateMediaRes>(url, 'POST', true, formData);
  return res.data;
}

export async function deleteMedia(mediaId: string) {
  const url = setURL(`/media/${mediaId}`, null);
  const res = await apiRequest<DeleteMediaRes>(url, 'DELETE', true, null);
  return res;
}

export async function getMediaByRefDocId(refDocId: string) {
  const url = setURL(`/media/by-ref-doc/${refDocId}`);
  const res = await apiRequest<GetByRefDocRes>(url, 'GET', true, null);
  return res.data;
}

export async function getMediasList() {
  return apiRequest<ListRes>('/media/list', 'GET', true);
}
